import React, {useState} from "react";
import {Container} from "react-bootstrap";
import {usePage} from "@inertiajs/react";
import PurposeBox from "../../Components/SalesAnalysis/PurposeBox.jsx";
import DataStatusBar from "../../Components/SalesAnalysis/DataStatusBar.jsx";
import CustomerHeadCard from "../../Components/SalesAnalysis/CustomerHeadCard.jsx";
import CustomerProductLineTable from "../../Components/SalesAnalysis/CustomerProductLineTable.jsx";
import CustomerLapsedTable from "../../Components/SalesAnalysis/CustomerLapsedTable.jsx";
import useAnalysisMeta from "../../Components/SalesAnalysis/useAnalysisMeta.js";
import useAnalysisData from "../../Components/SalesAnalysis/useAnalysisData.js";

const DEFAULT_THRESHOLD = 100;

/**
 * Kundenseite: Kopf mit Stammdaten und Zuständigkeit, Jahresvergleich je
 * Produktlinie, dazu "früher gekauft, jetzt nicht mehr" mit einstellbarer
 * Schwelle. `customerNumber` kommt als Inertia-Prop vom Controller
 * (Routenparameter), siehe plan.md AP6.
 */
export default function SalesAnalysisKunde() {
    const {customerNumber} = usePage().props;
    const {meta, metaError} = useAnalysisMeta();
    const [threshold, setThreshold] = useState(DEFAULT_THRESHOLD);
    const [reloadToken, setReloadToken] = useState(0);

    const {data, loading, error} = useAnalysisData(`/vertrieb/daten/kunde/${customerNumber}`, {
        threshold,
        _v: reloadToken,
    });

    return (
        <Container fluid className="pt-2 pb-4">
            <PurposeBox />
            <h1 className="h4 mb-2">Kunde</h1>
            {metaError && <div className="alert alert-warning">{metaError}</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <DataStatusBar meta={meta} onRecalculated={() => setReloadToken((t) => t + 1)} />
            <CustomerHeadCard customer={data?.customer} />
            <div className="d-flex flex-column gap-3">
                <CustomerProductLineTable productLines={data?.product_lines} meta={meta} reference={data?.reference} />
                <CustomerLapsedTable
                    rows={data?.lapsed}
                    threshold={threshold}
                    onThresholdChange={(value) => setThreshold(Number(value) || 0)}
                    loading={loading}
                    error={null}
                />
            </div>
        </Container>
    );
}
